import { render } from "./imageTeaser.vue?vue&type=template&id=1a44c105"
import script from "./imageTeaser.vue?vue&type=script&lang=js"
export * from "./imageTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__